export default __webpack_public_path__ + "static/media/person-icon2.5eb70adc.png";